import React, { useMemo } from "react";
import { FaMountainSun } from "react-icons/fa6";
import { GiGreekTemple } from "react-icons/gi";
import { GiBookCover } from "react-icons/gi";
import { ImSpoonKnife } from "react-icons/im";
import { FaGamepad } from "react-icons/fa";
import { MdFamilyRestroom } from "react-icons/md";
import { TbClock24 } from "react-icons/tb";
import { FaHistory } from "react-icons/fa";
import { FaHiking } from "react-icons/fa";
import { IoIosPin } from "react-icons/io";
import { FaTree } from "react-icons/fa6";
import { FaGlassMartiniAlt } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import { HiShoppingCart } from "react-icons/hi";
import { MdOutlineWaves } from "react-icons/md";
import { FaHandshakeAngle } from "react-icons/fa6";
import { MdSportsSoccer } from "react-icons/md";
import { FaTrainTram } from "react-icons/fa6";
import { MdHealthAndSafety } from "react-icons/md";
import { Typography, Flex, Tag } from "antd";

const GuideServicePill = ({ category }) => {
  const categoryIcons = {
    Adventure: <FaMountainSun />,
    Architecture: <GiGreekTemple />,
    "Art and Culture": <GiBookCover />,
    Culinary: <ImSpoonKnife />,
    Entertainment: <FaGamepad />,
    Family: <MdFamilyRestroom />,
    "Full Day Tour": <TbClock24 />,
    Historical: <FaHistory />,
    "Hiking and Walking": <FaHiking />,
    "Must Visit Sites": <IoIosPin />,
    "Nature and Wildlife": <FaTree />,
    Nightlife: <FaGlassMartiniAlt />,
    Photography: <FaCamera />,
    Shopping: <HiShoppingCart />,
    Sightseeing: <MdOutlineWaves />,
    "Social Impact": <FaHandshakeAngle />,
    Sport: <MdSportsSoccer />,
    "Transportation activities": <FaTrainTram />,
    Wellness: <MdHealthAndSafety />,
    Cultural: <GiBookCover />,
  };
  const restrictionsStyle = {
    border: "1px solid",
    borderRadius: 20,
  };
  const restrictionStyle = {
    ...restrictionsStyle,
    color: "black",
    borderColor: "#f0f0f0",
    backgroundColor: "#f0f0f0",
    padding: "5px 15px 5px 15px",
  };

  return (
    <Flex justify="center" align="center" style={restrictionStyle}>
      <Flex
        justify="center"
        align="center"
        style={{
          color: "black",
          borderColor: "#f0f0f0",
          backgroundColor: "#f0f0f0",
          marginTop: "2px",
          fontWeight: "400",
          // fontSize: "16px",
        }}
      >
        {categoryIcons[category] && <span>{categoryIcons[category]}</span>}
      </Flex>

      <Flex
        justify="center"
        align="center"
        style={{
          color: "black",
          borderColor: "#f0f0f0",
          backgroundColor: "#f0f0f0",
          marginLeft: "5px",
          fontWeight: "500",
          marginTop: "-2px",
          // fontSize: "16px",
        }}
      >
        {category}
      </Flex>
    </Flex>
  );
};

export default GuideServicePill;
